<ion-content>
  <ion-button expand="block" (click)="onOpenForms()" translate largeFont>Mobile.Forms.GeneralAccess</ion-button>
</ion-content>
